// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__kEzFK","info":"PatientInfo_info__30AVu"};